import { z } from 'zod'
import { InterestVariableEnum } from '../../../@shared/domain/enums/InterestVariable.enum'
import { SmartProcessingAudit } from '../../domain/entities/SmartProcessingAudit'

export const SmartProcessingAuditSchema = z
	.object({
		variavel_de_interesse: z.enum(InterestVariableEnum),
		modelo_ajustado_latex: z.string(),
		coeficientes_modelo_ajustado: z.array(z.number()),
		r2_ajustado: z.number(),
		erro: z.number(),
		erro_percentual: z.number(),
		// Ganho de parcelas e reducao do erro amostral podem nao vir (processamentos
		// anteriores ao calculo dessas metricas). Coalescem para 0, que para a tela
		// significa "nada a destacar": a tag so aparece com valor maior que zero.
		ganho_parcelas: z.number().nullish(),
		reducao_erro_percentual_amostral: z.number().nullish(),
		// Tolerante de proposito: uma variavel sem grafico gerado ainda tem
		// equacao, coeficientes e metricas para auditar. Derrubar o item inteiro
		// por causa do PNG esconderia o resto.
		identificador_grafico_residuos: z.string().nullish(),
	})
	.transform(
		(data) =>
			new SmartProcessingAudit(
				data.variavel_de_interesse,
				data.modelo_ajustado_latex,
				data.coeficientes_modelo_ajustado,
				data.r2_ajustado,
				data.erro,
				data.erro_percentual,
				data.ganho_parcelas ?? 0,
				data.reducao_erro_percentual_amostral ?? 0,
				data.identificador_grafico_residuos ?? '',
			),
	)
